// ══════════════════════════════════════════════════════════════
// COMPASS – Form save conflicts (US-024)
// ══════════════════════════════════════════════════════════════

/** 409 codes meaning the form was saved by someone else since it was loaded: the user must reload it (their
 *  unsaved changes are discarded). `stale-version` is the form's own optimistic lock; `concurrent-modification` is
 *  the database's, when two saves land at the same moment. */
export const FORM_CONFLICT_CODES: readonly string[] = [
  'error.kyc.form.stale-version',
  'error.concurrent-modification',
];

export function isFormConflict(status: number | undefined, code: string | undefined): boolean {
  return status === 409 && !!code && FORM_CONFLICT_CODES.includes(code);
}

/** Which form a save conflict is about. */
export type ConflictedForm = 'individual' | 'company';
